<template>
  <f7-block>
    <f7-block-title>{{ $t('marketplaceDashboard.sales') }}</f7-block-title>
    <div class="metric-grid">
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.totalSales') }}</span>
        <span class="metric-val">{{ fmt(data.totalSales) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.totalRevenue') }}</span>
        <span class="metric-val">{{ fmtCfa(data.totalRevenue) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.dailyRevenue') }}</span>
        <span class="metric-val">{{ fmtCfa(data.dailyRevenue) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.monthlyRevenue') }}</span>
        <span class="metric-val">{{ fmtCfa(data.monthlyRevenue) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.averageOrderValue') }}</span>
        <span class="metric-val">{{ fmtCfa(data.averageOrderValue) }}</span>
      </div>
    </div>
    <div v-if="data.revenueGrowthRate != null" class="trend-row">
      <span>{{ $t('marketplaceDashboard.revenueGrowthRate') }}</span>
      <span class="trend-pill" :class="trendClass(data.revenueGrowthRate)">
        {{ pct(data.revenueGrowthRate) }}
      </span>
    </div>

    <f7-block-title>{{ $t('marketplaceDashboard.shops') }}</f7-block-title>
    <div class="metric-grid">
      <div class="metric-card">
        <f7-icon f7="store" size="18" class="metric-icon color-teal" />
        <span class="metric-lbl">{{ $t('marketplaceDashboard.totalShops') }}</span>
        <span class="metric-val">{{ fmt(data.totalShops) }}</span>
      </div>
      <div class="metric-card">
        <f7-icon f7="store_fill" size="18" class="metric-icon color-green" />
        <span class="metric-lbl">{{ $t('marketplaceDashboard.activeShops') }}</span>
        <span class="metric-val">{{ fmt(data.activeShops) }}</span>
      </div>
      <div class="metric-card">
        <f7-icon f7="person" size="18" class="metric-icon color-orange" />
        <span class="metric-lbl">{{ $t('marketplaceDashboard.avgShopRating') }}</span>
        <span class="metric-val">{{ fmtDec(data.averageShopRating) }}</span>
      </div>
    </div>

    <f7-block-title>{{ $t('marketplaceDashboard.products') }}</f7-block-title>
    <div class="metric-grid">
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.totalProducts') }}</span>
        <span class="metric-val">{{ fmt(data.totalProducts) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.activeListings') }}</span>
        <span class="metric-val">{{ fmt(data.activeListings) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('marketplaceDashboard.outOfStockProducts') }}</span>
        <span class="metric-val">{{ fmt(data.outOfStockProducts) }}</span>
      </div>
    </div>
  </f7-block>
</template>
<script setup>
const props = defineProps({ data: { type: Object, required: true } });
function fmt(n) { return n != null ? Math.round(n).toLocaleString('fr-FR') : '-'; }
function pct(v) { return v != null ? v.toFixed(1) + '%' : '-'; }
function fmtCfa(v) { if (v == null) return '-'; const n = parseFloat(v) || 0; return n.toLocaleString('fr-FR', {maximumFractionDigits:0}) + ' FCFA'; }
function fmtDec(v, d=1) { return v != null ? parseFloat(v).toFixed(d) : '-'; }
function trendClass(v) { if (v > 0) return 'trend-up'; if (v < 0) return 'trend-down'; return 'trend-neutral'; }
</script>
<style scoped>
.metric-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; }
.metric-card { display:flex; flex-direction:column; align-items:center; gap:4px; padding:14px 8px; border-radius:12px; background:var(--f7-list-bg-color,#f5f5f5); }
.metric-icon { margin-bottom:2px; }
.metric-lbl { font-size:11px; color:var(--f7-on-surface-variant,#8e8e93); text-align:center; line-height:1.3; }
.metric-val { font-size:18px; font-weight:700; color:var(--f7-text-color,#333); }
.trend-row { display:flex; justify-content:space-between; align-items:center; margin:10px 0; padding:8px 12px; border-radius:8px; background:var(--f7-list-bg-color,#f5f5f5); font-size:13px; font-weight:500; }
.trend-pill { padding:4px 10px; border-radius:20px; font-size:12px; font-weight:600; }
.trend-up { background:color-mix(in srgb,#4caf50 12%,transparent); color:#4caf50; }
.trend-down { background:color-mix(in srgb,#f44336 12%,transparent); color:#f44336; }
</style>